<div class="content d-flex flex-row align-items-center justify-content-between section-title">
  <h2 [style.color]="control().labelColour">{{ control().label }}</h2>
  @if (control().showDate) {
    <mat-form-field appearance="fill" color="primary" class="compact">
      <mat-label>Report Date</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="value" (ngModelChange)="onValueChanges($event)" />
      <mat-datepicker #picker></mat-datepicker>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    </mat-form-field>
  }
</div>
